module.exports = __webpack_public_path__ + "static/header-4bb67265bce0e8b07e0c2c372998a650.jpg";